import { Provider, type ProviderProps } from "react-redux";
import { PersistGate, type PersistGateProps } from "redux-persist/integration/react";

import { configureStore } from "../../configureStore";

export const { store, persistor } = configureStore({ auth: { token: "TOKEN" } });

export type ReduxProviderProps = React.PropsWithChildren & {
  providerProps?: Partial<ProviderProps>;
  persistorProps?: Partial<PersistGateProps>;
};

export function ReduxProvider({ providerProps, persistorProps, children }: ReduxProviderProps) {
  // Expose Redux store globally for scripts that need access before React is fully initialized
  // This is used by the Tawk.to script to determine the correct URL based on isSpaceFlorida flag
  if (typeof window !== "undefined") {
    window.__REDUX_STORE__ = store;
    window.__REDUX_STORE_READY__ = true;

    // Dispatch an event to notify scripts that the Redux store is ready
    try {
      const event = new CustomEvent("REDUX_STORE_READY", { detail: { store } });
      document.dispatchEvent(event);
    } catch (e) {
      console.warn("Failed to dispatch REDUX_STORE_READY event", e);
    }
  }

  return (
    <Provider store={store} {...providerProps}>
      <PersistGate persistor={persistor} {...persistorProps}>
        {children}
      </PersistGate>
    </Provider>
  );
}
